import { Component, Input, OnInit } from '@angular/core';
import { City } from 'src/app/models/City';
import { MunicipiosService } from 'src/app/services/municipios.service';

@Component({
  selector: 'app-brasao',
  templateUrl: './brasao.component.html',
  styleUrls: ['./brasao.component.css'],
})
export class BrasaoComponent implements OnInit {

  @Input() municipio!: City;
  @Input() class!: string;

  brasao!: any;
  state: 'loading' | 'image' | 'fallback' = 'loading';


  constructor(private service: MunicipiosService) { }

  ngOnInit(): void {
    this.getUrlBrasao(this.municipio);
  }

  private getUrlBrasao(municipio: City) {
    this.service.getBrasaoUrl(municipio.uf, municipio.codigoIBGE)
      .subscribe({
        next: ({ url }) => {
          if (!url) {
            this.activateFallback();
            return;
          }

          this.service.getBrasaoFromUrl(url).subscribe({
            next: data => this.createImageFromBlob(data),
            error: () => this.activateFallback()
          });
        },
        error: () => this.activateFallback()
      });
  }

  private createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      this.brasao = reader.result;
      this.state = 'image';
    }, false);
    reader.addEventListener("error", () => {
      this.activateFallback();
    }, false);

    if (image && image.size == 0) {
      this.activateFallback();
      return;
    }
    reader.readAsDataURL(image);
  }

  private activateFallback() {
    this.state = 'fallback';
  }
}
